import { styled } from "@mui/material";
import { Link } from "react-router-dom";

/**
 * Allows use of 'sx' property with react-router Link component
 */
const StyledLink = styled(Link, {
  shouldForwardProp: (prop) =>
    prop !== "color" && prop !== "variant" && prop !== "sx",
  name: "StyledLink",
})({});

export default StyledLink;
